/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { mdiChevronDown } from '@mdi/js'

import { WhiteBlock } from 'components/Layout'
import { messages } from '../messages'
import {
  BreakerHeader,
  PanelInfoColumn,
  PanelInfoHeaderText,
  PanelInfoText,
  InfoGrid,
  StyledArrowIcon,
} from '../styles'
import { Panel } from 'features/home/types'
import { SpinnerCentered } from 'components/Loader'
import { H1 } from 'components/Typography'

interface PanelDataProps {
  panelData?: (Panel & { backup: string }) | null
  loaded: boolean
  isDesktop: boolean
}

function PanelData({ panelData, loaded, isDesktop }: PanelDataProps) {
  const { formatMessage } = useIntl()

  const [expanded, setExpanded] = useState(false)

  if (!panelData) return null

  const handleExpand = () => {
    if (isDesktop) return

    setExpanded(!expanded)
  }

  return (
    <WhiteBlock onClick={handleExpand}>
      {!loaded ? (
        <SpinnerCentered />
      ) : (
        <>
          <BreakerHeader>
            <H1>{panelData?.panelName}</H1>
            {!isDesktop && (
              <StyledArrowIcon
                path={mdiChevronDown}
                size={1}
                rotate={expanded ? 180 : 0}
              />
            )}
          </BreakerHeader>
          {!isDesktop && (
            <InfoGrid>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.hierarchy} />
                </PanelInfoHeaderText>
                <PanelInfoText>
                  {panelData?.panelHierarchy ?? '-'}
                </PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.mainBreakerFeed} />
                </PanelInfoHeaderText>
                <PanelInfoText>{`${panelData?.mainBreakerSize}A`}</PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.phase} />
                </PanelInfoHeaderText>
                <PanelInfoText>
                  {panelData?.phases === 2
                    ? formatMessage(messages.splitPhase)
                    : formatMessage(messages.threePhase)}
                </PanelInfoText>
              </PanelInfoColumn>
              {!isDesktop && expanded && (
                <>
                  <PanelInfoColumn>
                    <PanelInfoHeaderText>
                      <FormattedMessage {...messages.backupPowerSource} />
                    </PanelInfoHeaderText>
                    <PanelInfoText>{panelData?.backup ?? '-'}</PanelInfoText>
                  </PanelInfoColumn>
                  <PanelInfoColumn>
                    <PanelInfoHeaderText>
                      <FormattedMessage {...messages.linkedPBC} />
                    </PanelInfoHeaderText>
                    <PanelInfoText>{panelData?.mac[0] ?? '-'}</PanelInfoText>
                  </PanelInfoColumn>
                  <PanelInfoColumn>
                    <PanelInfoHeaderText>
                      <FormattedMessage {...messages.headerSize} />
                    </PanelInfoHeaderText>
                    <PanelInfoText>{`${panelData?.slotsNumber} ${formatMessage(
                      messages.slots
                    )}`}</PanelInfoText>
                  </PanelInfoColumn>
                  <PanelInfoColumn>
                    <PanelInfoHeaderText>
                      <FormattedMessage {...messages.columns} />
                    </PanelInfoHeaderText>
                    <PanelInfoText>{panelData?.slidesNumber}</PanelInfoText>
                  </PanelInfoColumn>
                  <PanelInfoColumn>
                    <PanelInfoHeaderText>
                      <FormattedMessage {...messages.headerRoom} />
                    </PanelInfoHeaderText>
                    <PanelInfoText>{panelData?.roomName ?? '-'}</PanelInfoText>
                  </PanelInfoColumn>
                  <PanelInfoColumn>
                    <PanelInfoHeaderText>
                      <FormattedMessage {...messages.headerType} />
                    </PanelInfoHeaderText>
                    <PanelInfoText>{panelData?.panelType ?? '-'}</PanelInfoText>
                  </PanelInfoColumn>
                </>
              )}
            </InfoGrid>
          )}

          {isDesktop && (
            <InfoGrid>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.hierarchy} />
                </PanelInfoHeaderText>
                <PanelInfoText>
                  {panelData?.panelHierarchy ?? '-'}
                </PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.mainBreakerFeed} />
                </PanelInfoHeaderText>
                <PanelInfoText>{`${panelData?.mainBreakerSize}A`}</PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.phase} />
                </PanelInfoHeaderText>
                <PanelInfoText>
                  {panelData?.phases === 2
                    ? formatMessage(messages.splitPhase)
                    : formatMessage(messages.threePhase)}
                </PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.backupPowerSource} />
                </PanelInfoHeaderText>
                <PanelInfoText>{panelData?.backup ?? '-'}</PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.linkedPBC} />
                </PanelInfoHeaderText>
                <PanelInfoText>{panelData?.mac[0] ?? '-'}</PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.headerSize} />
                </PanelInfoHeaderText>
                <PanelInfoText>{`${panelData?.slotsNumber} ${formatMessage(
                  messages.slots
                )}`}</PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.columns} />
                </PanelInfoHeaderText>
                <PanelInfoText>{panelData?.slidesNumber}</PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.headerRoom} />
                </PanelInfoHeaderText>
                <PanelInfoText>{panelData?.roomName ?? '-'}</PanelInfoText>
              </PanelInfoColumn>
              <PanelInfoColumn>
                <PanelInfoHeaderText>
                  <FormattedMessage {...messages.headerType} />
                </PanelInfoHeaderText>
                <PanelInfoText>{panelData?.panelType ?? '-'}</PanelInfoText>
              </PanelInfoColumn>
            </InfoGrid>
          )}
        </>
      )}
    </WhiteBlock>
  )
}

export default PanelData
